
import Events from '../events';
import $ from 'jquery';
import App from '../app';
import * as D from '~/data-utils';
import Map from './Map';
import Wayfinding from './Wayfinding';
import { getContact } from './store-contact';
import {
  scimddata as getScimddata,
  getStoreById,
  getStores
} from '../data-utils';


var storeinfo;
var context;

function init(appContext){
  context = appContext;
  var currentStore = App.getStoredData('currentStore', 'all');
  var { id } = currentStore.store;
  var storedata = getStoreById(id);
  var scimddata = getScimddata();
  var imddata = Map.getImdData(context);
  const { storeLocations = [{}], images = [], logoURL } = storedata;
  var mapStores = Map.getStoreData(storeLocations[0].floorIndex);

  const { mapType, scid } = context.imdSettings;

  if (mapType.inhouse) {
    Wayfinding.init(scimddata, imddata, context);
    Wayfinding.doFindShortestPathTree(imddata.floorIndex, {x: imddata.x, y: imddata.y});
  }

  Events.dispatchEvent('poi', { name: currentStore.store.name, action: 'detail' });

  var storeLocation = getStoreLocation(storedata);
  var fieldsOfBusiness = getStoreFieldsOfBusiness(storedata);
  var storeoffers = getOffers(id);
  var langs = D.langs();
  var lang = D.lang();
  var translations = App.getTranslations(langs);

  storeinfo = {
    id: id,
    storedata: storedata,
    contact: getContact(storedata),
    storeLocation: storeLocation,
    stores: getStores(),
    mapStores: mapStores,
    mapType,
    image: images[0] || logoURL,
    isImageLogo: !images[0] && !!logoURL,
    scid,
    scimddata: scimddata,
    fieldsOfBusiness: fieldsOfBusiness,
    storeOffers: storeoffers || '',
    icontitle: translations[lang]['common.storeDirectory'] || 'common.storeDirectory',
    curvedText: translations[lang]['store.touchToViewFullMap'] || 'store.touchToViewFullMap',
    iconsvg: context.resources.get('ic_store'),
    flooricon: 'ic_building',
    translations: translations,
    currentLang: lang,
    imddata: imddata
  };
  return storeinfo;
}

function getStoreLocation(store){

  var storeLocation = null;

  //get shop locations on the same floor
  var storeLocations = $.map(store.storeLocations, function(location){
    if(typeof store.floor != 'undefined'){
      if(location.floorIndex == store.floor.order){
        return location;
      }
    }
  });

  //if locations not found, try to find for other floors
  if($.isEmptyObject(storeLocations)){
    storeLocations = $.map(store.storeLocations, function(location){
      return location;
    });
  }

  //if more than one location, choose locations with mapVisibility 1
  if(storeLocations.length > 1){
    var locations = storeLocations.filter(function(item){
      if(item.mapVisibility==1){
        return item;
      }
    });
    //update array only if there is one or more locations with mapVisibility 1
    if(locations.length >= 1){
      storeLocations = locations;
    }
  }

  //if still more than one location, find the closest
  if(storeLocations.length > 1){
    if(typeof store.floor.order != 'undefined'){
      storeLocation = Wayfinding.findClosestStoreLocationForStoreAtFloor(store, store.floor.order);
    }else{
      storeLocation = storeLocations[0];
    }
  }else{
    storeLocation = storeLocations[0];
  }

  //if current floor hasn't any storespace, find the closest
  if(storeLocation == null || $.isEmptyObject(storeLocation)){
    storeLocation = Wayfinding.findClosestStoreLocationForStore(store);
  }

  if(storeLocation==null){
    storeLocation={};
  }

  storeLocation.floorId = Map.getFloorId(storeLocation.floorIndex);
  return storeLocation;
}

function getOffers(id){
  var lang = D.lang();
  var offerdata = App.getStoredData('offers', lang);
  var storeoffers = offerdata.offers.filter((offer) => {
    if(offer.store && offer.store.id==id){
      return offer;
    }
  });
  return storeoffers;
}

function getStoreFieldsOfBusiness(store){
  var lang = D.lang();
  var scdata = App.getStoredData('scdata', lang);
  var scFieldsOfBusiness = scdata.shoppingCenterData.fieldsOfBusiness;

  var fieldsOfBusiness = '';
  $.each(scFieldsOfBusiness, function(i, fob){
    if(fob.id == store.fieldOfBusinessId){
      fieldsOfBusiness = fob.description;
    }
  });

  $.each(scFieldsOfBusiness, function(i, fob){
    if(typeof store.additionalFieldOfBusinessIds != 'undefined'){
      $.each(store.additionalFieldOfBusinessIds, function(j, additionalFieldOfBusinessId){
        if(additionalFieldOfBusinessId == fob.id){
          fieldsOfBusiness += ', '+fob.description;
        }
      });
    }
  });

  return fieldsOfBusiness;
}

function toggleBlock(id){
  var block = id.replace('expand-', '');
  var blockelement = $('#'+block);
  var storeOwnExceptionalOpeningHour = $('.store-own-exceptional-opening-hour');
  if(blockelement.hasClass('block--expanded')){
    $('#'+block).removeClass('block--expanded').addClass('block--minimized');
    storeOwnExceptionalOpeningHour[0].style.display = 'none';
  }else{
    $('#'+block).removeClass('block--minimized').addClass('block--expanded');
    storeOwnExceptionalOpeningHour[0].style.display = 'block';
  }
}

function goToTips(){
  var currentStore = {store: {}, storeLocation: {}, showRoute: false};
  currentStore.store = storeinfo.storedata;
  App.saveLocally(currentStore, 'currentStore', 'all');
  window.location.href='#tips';
}

function goBack(){
  window.history.back();
}

function goTo(hash){
  window.location.href=hash;
}

export default {
  init,
  getStoreFieldsOfBusiness,
  toggleBlock,
  getStores,
  goBack,
  goToTips,
  goTo
};
